export { default as ContractInfo } from './ContactInfo';
